import { render, staticRenderFns } from "./FPotensIKawasanTenant.vue?vue&type=template&id=3d948b50&scoped=true"
import script from "./FPotensIKawasanTenant.vue?vue&type=script&lang=js"
export * from "./FPotensIKawasanTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d948b50",
  null
  
)

export default component.exports